import { Injectable } from '@angular/core';
import { WebUserAuthenticationService } from '@Authentication/web-user/web-user-authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService extends WebUserAuthenticationService {

}
